<template>
  <p>
    {{ showFullDescription ? description : limitDescription(description) }}
    <button
      v-if="limitDescription(description) !== description && !showFullDescription"
      type="button"
      class="text-ocean-600 hover:text-ocean-400 transition duration-150"
      @click.stop="showMoreDescription"
    >
      {{ $t('app.read-more') }}
    </button>
  </p>
</template>

<script>
export default {
  name: 'VetsterDescriptionItem',

  props: {
    description: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      showFullDescription: false,
    };
  },

  methods: {
    showMoreDescription() {
      this.showFullDescription = true;
    },

    limitDescription(text) {
      if (text.length <= 150) {
        this.showFullDescription = true;

        return text;
      }

      return `${text.substring(0, 150)}...`;
    },
  },
};
</script>
